

// regex more focused towards url matching
export const URL_REGEX = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi; // eslint-disable-line no-useless-escape

// regex for html tags
export const HTML_REGEX = /<|>/u;

// regex from backend
export const INVALID_NAME_REGEX = /https?:\/\/(?:[-\w.]|(?:%[\da-fA-F]{2}))*/g;

// English letters, spaces, hyphens and apostrophes (e.g. "Anne-Marie", "O'Brien")
export const ENGLISH_NAME_REGEX = /^[A-Za-z\s'-]+$/;

// Arabic letters and spaces (Unicode block U+0600-U+06FF)
export const ARABIC_NAME_REGEX = /^[؀-ۿ\s]+$/;

const validateName = (value, t, fieldName = 'name') => {
  let fieldError = '';
  if (!value.trim()) {
    fieldError = t('empty.name.field.error');
  } else if (URL_REGEX.test(value) || HTML_REGEX.test(value) || INVALID_NAME_REGEX.test(value)) {
    fieldError = t('name.validation.message');
  } else if (fieldName === 'name_ar') {
    if (!ARABIC_NAME_REGEX.test(value)) {
      fieldError = t('name.ar.validation.message');
    }
  } else if (!ENGLISH_NAME_REGEX.test(value)) {
    fieldError = t('name.en.validation.message');
  }
  return fieldError;
};

export default validateName;
